import useReveal from '../hooks/useReveal';
import ContactForm from '../components/ContactForm';
import FeaturedOn from '../components/FeaturedOn';

const Home = () => {
  useReveal();

  return (
    <>
      <section className="hero" id="home">
        <div className="hero-content">
          <div className="section-label">Investment Advisory</div>
          <h1>
            Your Financial Future,<br />
            Our Expertise
          </h1>
     
          <p className="focus-text">
            {/* Our Focus Is Long-Term Investing, Risk Awareness, And Financial
            Independence. Because Smart Money Decisions Today Secure Your
            Family&apos;s Tomorrow. */}
                        Most People Lack Guidance On Financial Planning And Debt Management. MyFundz Offers Proven, Jargon-Free, And Long-Term Wealth Creation. Early Guidance From A Certified Mutual Fund Service Makes A Big Difference.

          </p>

         {/* <p className="hero-text">
            Most People Lack Guidance On Financial Planning And Debt Management. MyFundz Offers Proven, Jargon-Free, And Long-Term Wealth Creation. Early Guidance From A Certified Mutual Fund Service Makes A Big Difference.
          </p> */}


          <div className="hero-cta">
            <button onClick={() => window.location.href = '/calculators'} className="cta-button">Get My Free EMI-to-Wealth Check</button>
          </div>
        </div>
        <div>
          <ContactForm />
        </div>
      </section>

            <section className="quick-inquiry">

        <div className="inquiry-content fade-in hero-content">
          {/* <div className="section-label">Support</div> */}
          <h2>Our Visionary Founder</h2>
          <p>
            <strong></strong>
          </p>
          <p>
           Our legacy is built on the vision of <b>Late N. Sankaran (1959–2025)</b>  of Pondicherry, 
           who spent over three decades establishing this organization with trust, integrity, 
           and a strong commitment to financial security. As a personal investment consultant, 
           he guided countless families with clarity and purpose, creating lasting 
           relationships within the community.

           <br></br>
          
          </p>
          <p>
                      Following his passing, his daughter <b>Meenatchi Sankaran</b> continues this legacy with over four years of experience, blending his values with a modern approach. She remains dedicated to personalised service, disciplined investing, and a client-first philosophy.

          </p>
          {/* <button className="cta-button">Get Started Now</button> */}
        </div>

                <div className="hero-image inquiry-visual">
           <img src='/images/home/founder.webp' alt="Quick Inquiry" style={{ width: "100%", height: "auto", borderRadius: "20px" }} />
        </div>


      </section>

      <section className="quick-inquiry">
        <div className="hero-image inquiry-visual">
           <img src='/images/home/founder_meenatchi.webp' alt="Quick Inquiry" style={{ width: "100%", height: "auto", borderRadius: "20px" }} />
        </div>
        <div className="inquiry-content fade-in hero-content">
          <div className="section-label">Support</div>
          <h2>"Need Help?" – Quick Inquiry</h2>
          <p>
            <strong>Struggling With EMIs, Savings, Or Choosing The Right Investments?</strong>
          </p>
          <p>
            Most People Lack Guidance On Financial Planning And Debt Management.
            MyFundz Offers Proven, Jargon-Free, And Long-Term Wealth Creation. Early
            Guidance From A Certified Mutual Fund Service Makes A Big Difference.
          </p>
          <p>Start With A Free EMI-To-Wealth Check Today.</p>
          <button onClick={()=> window.location.href = "/services"} className="cta-button">Get Started Now</button>
        </div>
      </section>

      <section className="stats-bar">
        <div className="stat-item fade-in">
          <h3>Total Clients</h3>
          <div className="number">500+</div>
        </div>
        <div className="stat-item fade-in">
          <h3>AUM</h3>
          <div className="number">30 Crore+</div>
        </div>
        <div className="stat-item fade-in">
          <h3>Since</h3>
          <div className="number">1985</div>
        </div>
      </section>

      <section className="services" id="services">
        <div className="services-grid">
          <div className="services-visual">
            <img src="/images/home/Rectangle 53.webp" alt="Our Services" style={{ width: "100%", height: "auto", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }} />
          </div>
          <div className="services-content fade-in">
            <div className="section-label">Our Expertise</div>
            <h2>Overview Of Services</h2>
            <p>
              MyFundz Provides Comprehensive Investment Advisory And Portfolio
              Management Services. We help clients from undefined savings to structural finance planning.
            </p>
            <button onClick={()=> window.location.href = "/services"} className="cta-button">Explore All Services</button>
          </div>
        </div>
      </section>

      <section className="client-feedback">
        <div className="feedback-container fade-in">
          <h2 className="feedback-title">CLIENT FEEDBACK</h2>
          <p className="feedback-text">
            As a layman in the field I always felt the need for financial literacy and 
            guidance which I started working on through you tube channels, news paper articles and colleagues advises 
            but ended in mishapes, I was deeply worried for the financial insecurities not planning for a retirement 
            life until I met you regarding the financial services you always had the customers personalized plans not 
            threatening or burdening but clearly stably brought the habit of saving.. you were always kind and polite 
            even to my craziest doubts.. repeated doubts and always guided me in needed moments I appreciate your 
            commitment round the clock attending to the calls despite ur busy schedule and brought confidence in me.. 
            truly appreciate your painstaking efforts and wishing you good health and wellness and happiness in your 
            chosen career, blessed to have you.
          </p>
          <p className="feedback-author">DR. PARIMALA</p>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-container">
          <h2>Ready to Secure Your Future?</h2>
          <p>Looking For A Reliable Financial Advisor Near You?</p>
          <p>
            Whether You&apos;re Starting Early Or Recovering Late, Use The Right Plan
            Works. Get Personalized Guidance On Retirement Or Conflict-Free Mutual Fund
            Advice. Let&apos;s Begin Your Journey Today.
          </p>
          <button onClick={()=> window.location.href = "/contact"} className="cta-button white">Let&apos;s Talk Today</button>
        </div>
      </section>

      <FeaturedOn />
    </>
  );
};

export default Home;
